// test2280
(2280 && 0);
